import { Component, OnInit } from "@angular/core";
import { AppService } from "../app.service";
import { NgxSpinnerService } from "ngx-spinner";
@Component({
  selector: "app-terms",
  templateUrl: "./terms.component.html",
  styleUrls: ["./terms.component.css"],
})
export class TermsComponent implements OnInit {
  data: any;
  errStatus: boolean
  constructor(
    private appService: AppService,
    private spinner: NgxSpinnerService
  ) {
    window.scrollTo(0, 0);
  }

  ngOnInit(): void {
    this.spinner.show();
    this.appService.footerContent({ type: "terms" }).subscribe((res) => {
      if (res) {
        this.spinner.hide();
        this.data = res;
      } else {
        this.spinner.hide();
        this.data = [];
      }
    }, err => {
      if (err) {
        this.spinner.hide();
        this.data = [];
        this.errStatus = true
      }
    });
  }
}
